/* istanbul ignore file */
import useFieldHelper from '../fieldHelper';
import { BaseFieldLayoutType, FieldProps } from '../types';
import TextField from './TextField';
import React, { useCallback, useState } from 'react';
import { useShowContext } from 'framework/show';
import { getValue, getLabel } from 'framework/utils';
import { useUiTheme } from 'framework/uiTheme';
import classnames from 'classnames';
import { Modal } from 'framework/ui/ui-builder';
import { Box } from '@mui/material';

type LongTextFieldValue = string | number | React.ReactElement | React.ReactElement[];

const LongTextField = ({
  source = '',
  value,
  title,
  label,
  isSortable,
  className,
  isColumnDirection,
}: FieldProps<LongTextFieldValue>) => {
  const { data } = useShowContext();
  const { getValue: getValueFromFieldHelper } = useFieldHelper({ source });
  const { BaseFieldLayout, Button } = useUiTheme<BaseFieldLayoutType>();

  const getFieldValue = () => {
    const valueFromShowContext = getValue(value, (src?: string) => data && data.getValueBySource(src!), source, '');

    if (valueFromShowContext) {
      return valueFromShowContext;
    }

    return getValueFromFieldHelper();
  };
  const fieldValue = getFieldValue();

  const [modalOpen, setModalOpen] = useState(false);

  const closeModal = useCallback(() => {
    setModalOpen(false);
  }, []);

  return (
    <>
      <Box
        role="button"
        tabIndex={0}
        onKeyPress={() => {}}
        sx={{
          '& .form-control': {
            border: 'none !important',
            textAlign: 'left !important',
            verticalAlign: 'middle',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            height: '40px',
            maxWidth: '100%',
            cursor: 'pointer',
          },
        }}
        onClick={(e: React.MouseEvent<HTMLElement>) => {
          setModalOpen(true);
          (e.target as HTMLElement).blur();
        }}
      >
        <BaseFieldLayout
          isColumnDirection={isColumnDirection}
          label={getLabel(label, source)}
          value={fieldValue ? `${fieldValue.substring(0, 100)}...` : ''}
          isSortable={isSortable}
          className={classnames(className)}
        />
      </Box>
      <Modal
        backdrop="static"
        isOpen={modalOpen}
        title={title}
        onToggle={closeModal}
        hasCancelButton={false}
        className="form-modal"
        buttons={[
          <Button variant="outlined" key="ok-modal-btn" onClick={closeModal}>
            Ok
          </Button>,
        ]}
      >
        <Box sx={{ whiteSpace: 'pre-wrap' }}>
          <TextField source={source} />
        </Box>
      </Modal>
    </>
  );
};

export default LongTextField;
